import React, { useState, useEffect } from "react";
import {
  BarChart2,
  ChevronDown,
  ChevronUp,
  Inbox,
  XCircle,
  Activity,
  Users,
  User,
  UserPlus,
  BellRing
} from "lucide-react";
import logo1 from "../assets/brand/images.png";
import dataEn from "../dataEn";
import dataKin from "../dataKin";
import { language } from "../tools/language";
const data = language === "en" ? dataEn : dataKin;

function Mobile({ onMenuClick }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dashboardSubMenuOpen, setDashboardSubMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState("");
  const [userPosition, setUserPosition] = useState("");

  // Get user position from localStorage on component mount
  useEffect(() => {
    const position = localStorage.getItem("position");
    if (position) {
      setUserPosition(position);
    }
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const toggleDashboardSubMenu = (e) => {
    e.preventDefault();
    setDashboardSubMenuOpen(!dashboardSubMenuOpen);
  };

  // Base menu items that all users can see
  const baseMenuItems1 = [
    { key: "allChristian", icon: <Users />, title: data.menu.allChristian },
    { key: "allChildren", icon: <Users />, title: data.menu.allChildren },
    { key: "viewReport", icon: <Inbox />, title: data.menu.report },
  ];

  // Menu items that only admin/administrator can see
  const adminMenuItems = [
    { key: "addChristian", icon: <UserPlus />, title: data.menu.addChristian },
    // Add other admin-only menu items here
  ];

  // Combine menu items based on user position
  const menuItems1 = userPosition === "staff" 
    ? baseMenuItems1 
    : [...baseMenuItems1, ...adminMenuItems];

  const menuItems2 = [
    { key: "announcement", icon: <BellRing />, title: data.menu.announcement },
  ];

  const handleMenuClick = (menuKey, e) => {
    if (e) e.preventDefault();
    setActiveMenu(menuKey);
    onMenuClick(menuKey);
    // Close mobile menu after clicking
    setMenuOpen(false);
  };

  // Open dashboard submenu by default when mobile menu opens
  useEffect(() => {
    if (menuOpen) {
      setDashboardSubMenuOpen(true);
    }
  }, [menuOpen]);

  return (
    <div className="mobile-menu md:hidden">
      <div className="mobile-menu-bar w-[90%]">
        <a href="/" className="flex mr-auto">
          <img alt="" className="w-8 ml-10" src={logo1} />
        </a>
        <button className="mobile-menu-toggler" onClick={toggleMenu}>
          {menuOpen ? (
            <XCircle className="w-8 h-8 text-white transform -rotate-90" />
          ) : (
            <BarChart2 className="w-8 h-8 text-white transform -rotate-90" />
          )}
        </button>
      </div>
      {menuOpen && (
        <div className="scrollable">
          <ul className="scrollable__content py-2">
            <li>
              <a
                href="#"
                className="menu menu--active"
                onClick={toggleDashboardSubMenu}
                style={{
                  backgroundColor: activeMenu === "dashboard" ? "#164E63" : "",
                  color: activeMenu === "dashboard" ? "white" : "",
                }}
              >
                <div className="menu__icon">
                  <Activity />
                </div>
                <div className="menu__title">
                  {data.names.firstName} {data.names.lastName}
                  <div className="side-menu__sub-icon transform rotate-180">
                    {dashboardSubMenuOpen ? (
                      <ChevronDown className="menu__sub-icon" />
                    ) : (
                      <ChevronUp className="menu__sub-icon" />
                    )}
                  </div>
                </div>
              </a>
              <ul className={dashboardSubMenuOpen ? "menu__sub-open" : "hidden"}>
                {menuItems1.map((item) => (
                  <li key={item.key}>
                    <a
                      href="#"
                      onClick={(e) => handleMenuClick(item.key, e)}
                      className="menu"
                      style={{
                        backgroundColor: activeMenu === item.key ? "#164E63" : "",
                        color: activeMenu === item.key ? "white" : "",
                      }}
                    >
                      <div className="menu__icon">{item.icon}</div>
                      <div className="menu__title">{item.title}</div>
                    </a>
                  </li>
                ))}
              </ul>
            </li>

            {menuItems2.map((item) => (
              <li key={item.key}>
                <a
                  href="#"
                  onClick={(e) => handleMenuClick(item.key, e)}
                  className="menu"
                  style={{
                    backgroundColor: activeMenu === item.key ? "#164E63" : "",
                    color: activeMenu === item.key ? "white" : "",
                  }}
                >
                  <div className="menu__icon">{item.icon}</div>
                  <div className="menu__title">{item.title}</div>
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default Mobile;